"use strict";

module.exports = {
  ColorSwatchRep: require('./ColorModels').ColorSwatchRep,
  ColorSwatch: require('./ColorModels').ColorSwatch,
  ColorConverters: require('./ColorConverters').default,
  ColorWorker: require('./ColorExtractor.worker'),
  ColorMoods: require('./ColorModels').COLORMOODS
};